module.exports = __webpack_public_path__ + "media/images/doctor2-29ed575f7f3ffa61d0252a3b0a4b792d.png";